import { useQuery } from '@ts-core/lib/apollo';

import {
  getMultipleChoiceExerciseQuery,
  GetMultipleChoiceExerciseQueryResult,
  GetMultipleChoiceExerciseQueryVariables,
} from '../graphql/queries/getMultipleChoiceExerciseQuery';

import { MultipleChoiceExercise } from '../types';

interface MultipleChoiceExerciseInput {
  courseId: string;
  subjectId: string;
  exerciseId?: string;
}

interface MultipleChoiceExerciseOutput {
  exercise?: MultipleChoiceExercise;
  loading: boolean;
}

export default function useMultipleChoiceExercise(input: MultipleChoiceExerciseInput): MultipleChoiceExerciseOutput {
  const { courseId, subjectId, exerciseId } = input;
  const { data, loading } = useQuery<GetMultipleChoiceExerciseQueryResult, GetMultipleChoiceExerciseQueryVariables>(getMultipleChoiceExerciseQuery, {
    variables: {
      courseId,
      subjectId,
      exerciseId,
    },
    skip: !exerciseId,
  });

  return {
    exercise: data?.multipleChoiceExercise,
    loading,
  };
}
